<div class="text-center mx-7 top-margin">
  <h1>Page not found...</h1>
  <h2>but mentoring with Femme Palette helps you to find what you're looking for.</h2>
  <button routerLink="/">Go to Homepage</button>
</div>
